import React, { useState } from 'react'
import ThemeSwitch from '../common/themeSwitch/ThemeSwitch'
import _ from 'lodash'
import { Link } from 'react-router-dom';
import { postUserLog } from '../../actions/common'

export default props => {
    const { activeSites, showThemeSwitch, hideSiteCount, sbg, activeSiteCnt, container = "" } = props;
    const [showAllSites, setShowAllSites] = useState(false);

    const activeSitesTpl = () => {
        //let siteList = _.take(activeSites, showAllSites ? 10 : 5);
        let siteList = _.take(activeSites, 5);
        let tpl = siteList.map((data, i) => <Link key={data.siteId} to={'/sitehome/' + sbg + '/' + data.siteId} ><button data-active-sites="all" className="btn btn-primary" onClick={() => postUserLog({ event: 'Clicked Pinned Site', data: { action: data.siteName + ' Site selected ', module: 'Site Screen', section: 'Pinned Site', siteUId: data.siteId, widget: '', } })} > <i className="icon icon-pinned"></i> {data.siteName}  ({data.siteId})</button></Link >)
       // if (activeSites.length > 5)
        //    tpl.push(<button key={'btnfooter'} onClick={() => setShowAllSites(!showAllSites)} data-active-sites="all" className="btn btn-primary"> <i className="icon icon-pinned"></i>{showAllSites ? 'Less' : 'More'}</button>)
        return tpl;
    }

    const showTotal = hideSiteCount ? true : false;

    return (
        <footer className={container} >
            <div className="sites">
                {!showTotal && <div className="active-sites">
                    <span className="counts">{activeSiteCnt}</span>
                    <span className="label">Active Sites</span>
                </div>
                }
                {activeSites.length > 0 &&


                    <div className="pinned-sites">

                        {
                            activeSitesTpl()

                        }
                    </div>
                }
            </div>

            {/* Theme switcher  */}

            {showThemeSwitch && <ThemeSwitch />}
        </footer>
    )
}



